module.exports = __webpack_public_path__ + "img/notconnect_temp.03d43d08.svg";